
<style>
  body {
    background-color: #bfbfbf !important;
  }
</style>

<div>
  <app-header></app-header>
  <router-outlet></router-outlet>
</div>


